import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-form-student',
  templateUrl: './form-student.component.html',
  styleUrls: ['./form-student.component.scss']
})
export class FormStudentComponent implements OnInit {

  private readonly API_FORM = 'api/formulario';

  public name:string = "";

  /* Child References */
  createForm: FormGroup = this.fb.group({
    nombre: ['', [Validators.required]],
    apellido: ['', [Validators.required]],
    correo: ['', [Validators.required, Validators.email]],
    anioInteres: ['', [Validators.required]],
    edad: ['', [Validators.required]],
    telefono: ['', [Validators.required, Validators.min(1000000000), Validators.max(9999999999)]],
    programa: ['', [Validators.required]],
    pregunta: ['', [Validators.required]],
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: { student: any },
    private dialogRef: MatDialogRef<FormStudentComponent>,
    private fb: FormBuilder,
    private apiService: ApiService,
    private alertService: AlertService,) {
    }

  ngOnInit(): void {
    this.name = this.data.student.nombre.split(" ")[0];
  }

  /**
   * Validate that the fields are correct
   * @param field field to validate
   */
   public validField({ field }) {
    return (
      this.createForm.controls[field].errors &&
      this.createForm.controls[field].touched &&
      this.createForm.controls[field].invalid
    );
  }

  onSubmit({ event }): void {
    if (this.createForm.valid) {
      const form = {
        nombre: this.createForm.controls.nombre.value,
        apellido: this.createForm.controls.apellido.value,
        correo: this.createForm.controls.correo.value,
        anioInteres: this.createForm.controls.anioInteres.value,
        edad: this.createForm.controls.edad.value,
        telefono: this.createForm.controls.telefono.value,
        programa: this.createForm.controls.programa.value,
        pregunta: this.createForm.controls.pregunta.value,
        fuente: "Contacta estudiante: "+this.data.student.nombre+" - "+this.data.student.universidad?.nombre,
      };
      this.createFormByContact({ form });
      this.dialogRef.close();
    } else {
      this.createForm.markAllAsTouched();
    }
  }

  /**
   * create a form
   * @param form
   */
  public async createFormByContact({ form }) {
    let resp = await this.apiService
      .post({ api: `${this.API_FORM}`, data: form })
      .toPromise();
    if (resp.success) {
      this.createForm.reset();
      this.alertService.showSuccess({
        msg: `Formulario creado`,
      });
    }
  }

}
